import repeat from 'lib/repeat'

let fillEmpty = (len, filler) => repeat(filler, len[0] + len[1]) + '&thinsp;'

export default fillEmpty


/** WEBPACK FOOTER **
 ** ./src/scripts/components/ComplexTable/fillEmpty.js
 **/